import React, {useRef} from 'react';

const emptyGovernmentId = () => ({ typeId: '', idNumber: '' });

export default function GovernmentIdForm({ governmentIds = [], governmentIdTypes = [], onChange, employeeId, api }) {
  const fileRefs = useRef({});

  const add = () => onChange([...governmentIds, emptyGovernmentId()]);
  const remove = (i) => onChange(governmentIds.filter((_, idx) => idx !== i));
  const update = (i, field, value) => {
    const updated = governmentIds.map((govId, idx) => {
      if (idx !== i) return govId;
      const next = { ...govId, [field]: value };
      if (field === 'typeId') {
        const type = governmentIdTypes.find(t => t.id === value);
        next.typeName = type?.name || '';
      }
      return next;
    });
    onChange(updated);
  };

  const handleUpload = async (i, file) => {
    const govId = governmentIds[i];
    if (!govId.id || !employeeId || !api) return;
    const formData = new FormData();
    formData.append('file', file);
    const res = await api(`/hcm/employees/${employeeId}/government-ids/${govId.id}/documents`, { method: 'POST', body: formData });
    if (res.ok) {
      const newDoc = await res.json();
      const next = [...governmentIds];
      next[i] = { ...next[i], documents: [...(next[i].documents || []), newDoc] };
      onChange(next);
    }
  };

  const handleView = async (govId, docId) => {
    if (!employeeId || !api) return;
    const res = await api(`/hcm/employees/${employeeId}/government-ids/${govId.id}/documents/${docId}`);
    if (res.ok) {
      const data = await res.json();
      window.open(data.url, '_blank');
    }
  };

  const handleRemoveDoc = async (i, docId) => {
    const govId = governmentIds[i];
    if (!employeeId || !api) return;
    await api(`/hcm/employees/${employeeId}/government-ids/${govId.id}/documents/${docId}`, { method: 'DELETE' });
    const next = [...governmentIds];
    next[i] = { ...next[i], documents: (next[i].documents || []).filter(d => d.id !== docId) };
    onChange(next);
  };

  const input = "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-inset focus:ring-indigo-600";
  const select = "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-inset focus:ring-indigo-600";

  return (
    <div className="space-y-3">
      {governmentIds.map((govId, i) => (
        <div key={i} className="p-3 border border-gray-200 rounded-lg space-y-2">
          <div className="flex items-center justify-between">
            <div className="text-sm font-medium text-gray-700">Government ID {i + 1}</div>
            <button type="button" onClick={() => remove(i)} className="text-gray-400 hover:text-red-600 px-2">&times;</button>
          </div>
          <select value={govId.typeId} onChange={(e) => update(i, 'typeId', e.target.value)} className={select}>
            <option value="">Select ID Type</option>
            {governmentIdTypes.map(type => (
              <option key={type.id} value={type.id}>{type.name}</option>
            ))}
          </select>
          <input
            type="text"
            placeholder="ID Number"
            value={govId.idNumber}
            onChange={(e) => update(i, 'idNumber', e.target.value)}
            className={input}
          />
          {govId.id && api && (
            <div className="space-y-1">
              {(govId.documents || []).map(doc => (
                <div key={doc.id} className="flex items-center gap-2 text-sm">
                  <button type="button" onClick={() => handleView(govId, doc.id)} className="text-indigo-600 hover:text-indigo-800 truncate max-w-[200px]" title={doc.fileName}>
                    📎 {doc.fileName}
                  </button>
                  <button type="button" onClick={() => handleRemoveDoc(i, doc.id)} className="text-red-500 hover:text-red-700">&times;</button>
                </div>
              ))}
              <input type="file" ref={el => fileRefs.current[i] = el} className="hidden" accept="image/*,.pdf" onChange={(e) => { if (e.target.files[0]) { handleUpload(i, e.target.files[0]); e.target.value = ''; } }} />
              <button type="button" onClick={() => fileRefs.current[i]?.click()} className="text-sm text-indigo-600 hover:text-indigo-800">+ Attach document</button>
            </div>
          )}
        </div>
      ))}
      <button type="button" onClick={add} className="text-sm text-indigo-600 hover:text-indigo-800">+ Add government ID</button>
    </div>
  );
}
